import { render, staticRenderFns } from "./MemberSetup.vue?vue&type=template&id=03837635&scoped=true&"
import script from "./MemberSetup.vue?vue&type=script&lang=js&"
export * from "./MemberSetup.vue?vue&type=script&lang=js&"
import style0 from "./MemberSetup.vue?vue&type=style&index=0&id=03837635&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03837635",
  null
  
)

export default component.exports